import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import { useEffect, useState } from "react";

const Review = () => {
  const reviewList = [
    {
      src: "/images/review1.png",
      txt: `집정리를 제대로 안해 버려야 할<br/>
쓰레기와 폐기물이 한무더기였는데요<br/>
사장님께서 잘 해결해주셨답니다`,
    },
    {
      src: "/images/review2.png",
      txt: `고독사 현장을 문의드렸는데<br/>
처음 문의드리는거라 참 막막했는데도<br/>
친절하게 설명해주셔서 좋았어요`,
    },
    {
      src: "/images/review3.png",
      txt: `집을 오래비워놔서 이참에 싹 정리할 겸<br/>
문의를 드렸는데 비대면으로도<br/>
깔끔하게 잘 처리해주시더라구요`,
    },
    {
      src: "/images/review4.png",
      txt: `어머님 집을 정리하려고 문의드렸는데<br/>
만족스럽게 싹 잘 정리해주셔서<br/>
너무 감사했습니다.`,
    },
    {
      src: "/images/review5.png",
      txt: `이사가기 위해 집을 싹 비워달라고<br/>
요청을 드렸는데 기대이상으로<br/>
다 처리해주셔서 만족했습니다.`,
    },
    {
      src: "/images/review6.png",
      txt: `어머님이 요양병원에 입원하시게 되어<br/>
집을 정리하기 위해 문의드렸는데<br/>
참 잘해주셔서 정말 감사합니다.`,
    },
    {
      src: "/images/review7.png",
      txt: `자살현장 청소를 요청드렸는데<br/>
확실히 전문가셔서 그런지 그 힘든<br/>
현장을 깔끔하게 잘 해주시더라구요`,
    },
    {
      src: "/images/review8.png",
      txt: `시골집 정리 요청을 드렸는데<br/>
하루만에 다 끝내주셔가지고<br/>
돈을 많이 절약할 수 있었습니다.`,
    },
    {
      src: "/images/review9.png",
      txt: `간단한 창고정리 문의드렸는데<br/>
당일에 오셔서 후다닥 빠르게<br/>
해주시고 가시더라구요`,
    },
    {
      src: "/images/review10.png",
      txt: `각종 폐기물들과 가전 가구들을<br/>
정리하고자 도움을 요청드렸는데<br/>
싹 다 처리해주셔서 감사했어요`,
    },
  ];

  const [count, setCount] = useState(5);

  useEffect(() => {
    if (window.innerWidth > 800) {
      setCount(5);
    } else {
      setCount(1);
    }

    window.addEventListener("resize", () => {
      if (window.innerWidth > 800) {
        setCount(5);
      } else {
        setCount(1);
      }
    });

    return () => {
      window.removeEventListener("resize", () => {
        if (window.innerWidth > 800) {
          setCount(5);
        } else {
          setCount(1);
        }
      });
    };
  }, []);

  useEffect(() => {});
  return (
    <div id="review" className="relative w-full h-full py-14 lg:py-28 xl:pb-36">
      <div
        id="title"
        className="relative w-full h-fit text-center mb-10 xl:mb-20"
      >
        <h2 className="font-normal">
          청소의&nbsp;달인의 <span className=" text-secondary">고객후기</span>
        </h2>
      </div>
      <Swiper
        spaceBetween={30}
        // centeredSlides={true}
        loop={true}
        slidesPerView={count}
        autoplay={{
          delay: 3500,
          disableOnInteraction: false,
        }}
        modules={[Autoplay]}
        className=" relative w-full h-full mx-auto grid"
      >
        {reviewList.map((v, i) => (
          <SwiperSlide
            key={i}
            className=" relative w-full h-full min-w-72 px-5 lg:px-0 "
          >
            <div className=" relative w-full h-full py-5">
              <div className="relative w-full h-10 max-w-44 mx-auto mb-2 animate-bounce ">
                <img
                  src="/images/iconStar.png"
                  alt="star"
                  className=" relative w-full h-fit object-contain"
                />
              </div>
              <div className="relative w-full h-[calc(100%-40px)] min-h-72 p-3 rounded-2xl bg-white border shadow-md">
                <img
                  className="relative w-full h-auto object-cover object-center rounded-3xl"
                  src={v.src}
                  alt="review"
                />
                <div className=" relative w-full h-fit text-center pt-5">
                  <p
                    className="text-black"
                    dangerouslySetInnerHTML={{ __html: v.txt }}
                  ></p>
                </div>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default Review;
